import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

const initialState = {
  data: [],
  status: "idle",
};

export const getStatusEvents = createAsyncThunk(
  "/status-events/get",
  async () => {
    let res = axios
      .get("status-events", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .catch((err) => {
        console.log(err);
        // setError(err.response.data.message)
      });

    const data = await res;
    console.log(data);
    return data.data.events;
  }
);

export const createStatusEvents = createAsyncThunk(
  "/status-events/create",
  async (item) => {
    let res = axios
      .post("status-events", item, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .catch((err) => {
        console.log(err);
        // setError(err.response.data.message)
      });

    const data = await res;
    console.log(data);
    if (data.data.success) {
      alert("Status event yaratildi");
    }
  }
);

export const deleteStatusEvents = createAsyncThunk(
  "/status-events/delete",
  async (item) => {
    let res = axios
      .delete(`status-events/${item._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .catch((err) => {
        console.log(err);
        // setError(err.response.data.message)
      });

    const data = await res;
    console.log(data);
    if (data.data.success) {
      alert("Status event o'chirildi");
    }
  }
);

const statusEvents = createSlice({
    name: 'status',
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
      .addCase(getStatusEvents.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getStatusEvents.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getStatusEvents.fulfilled,(state, action) => {
        // state.status = "idle";
        console.log(action.payload, 'payload');
        state.data = action.payload;
        state.status = 'succeeded'
      })
      .addCase(createStatusEvents.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      .addCase(deleteStatusEvents.fulfilled, (state, action) => {
        state.status = 'idle'
      })
      }
  });
export const reducer = statusEvents.reducer;